<template>
	<div>
		<div class="row">
            <div class="col-md-12">
                <h4>CAFE OVERVIEW</h4>
            </div>
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-3 mb-3">
						<ListCompare title="SALES" unit="M" div=1000000000 :data="ytd.sales.rekap" itemcol="Info" valuecol="Value" url=""/>
					</div>
					<div class="col-md-3 mb-3">
						<ListCompare title="LOSSES" unit="Jt" div=1000000 :data="ytd.losses.rekap" itemcol="Info" valuecol="Value" comp=-1 url=""/>
					</div>

					<div class="col-md-3 mb-3">
						<ListCompare title="SALES PER DAY" unit="Jt" div=1000000 :data="ytd.sales.spd" itemcol="Info" valuecol="Value" url=""/>
					</div>
					<div class="col-md-3 mb-3">
						<ListCompare title="MARGIN" unit="%" :data="ytd.margin.rekap" itemcol="Info" valuecol="Value" url=""/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-3">
						<BarCard title="SALES YTD (M)" :data="ytd.sales.ytdchart" :width="500" :height="280" url=""/>
					</div>
					<div class="col-md-3">
						<BarCard title="SALES MTD (M)" :data="ytd.sales.mtdchart" :width="500" :height="280" url=""/>
					</div>
					<div class="col-md-3">
						<BarCard title="MARGIN YTD (%)" :data="ytd.margin.ytdchart" :width="500" :height="280" url=""/>
					</div>
					<div class="col-md-3">
						<BarCard title="MARGIN MTD (%)" :data="ytd.margin.mtdchart" :width="500" :height="280" url=""/>
					</div>
				</div>
			</div>

			<div class="col-md-4 pr-0" v-if="false">
				<div class="row">
					<ListItem title="CAFE BY AREA" prefix="AREA" :data="store.area" itemcol="SalesArea" valuecol="StoreCnt"/>
					<ListItem title="CAFE BY PROVINCE" :data="store.province" itemcol="ProvinceName" valuecol="StoreCnt"/>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import Cafe from '@/components/page/Cafe.js'
import { Rainbow, Rainbow2, FuelColor, Config, AppColors, Penanggalan, AxiosWithJar } from '@/utility.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare2.vue'
import Footer from '@/views/Footer.vue'

export default{
	extends: Cafe,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		Footer
	},
    props: {
        intervalDuration: {
            type: Number,
            required: false,
            default: 15,
        },
        autoRequestActive: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            autoRequestInterval: null // Save interval ID
        }
    },
    mounted() {
		//this.loadYTD();
		//this.loadStore(); //Unused

        if(this.autoRequestActive) {
            this.startAutoRequest();
        }
    },
    beforeDestroy() {
        // Stop interval when component destroyed
        if (this.autoRequestInterval) {
            clearInterval(this.autoRequestInterval);
        }
    },
    watch : {
        // Watcher untuk mendeteksi perubahan status auto request
        autoRequestActive(newValue) {
            if (newValue) {
                this.startAutoRequest();
            } else {
                this.stopAutoRequest();
            }
        },
        // Watcher untuk mendeteksi perubahan interval durasi
        intervalDuration(newValue) {
            if (this.autoRequestActive) {
                this.updateInterval();
            }
        },
	},
    methods:{
        startAutoRequest() {
            if (this.autoRequestInterval) {
                clearInterval(this.autoRequestInterval); // Hentikan interval lama
            }

            this.loadYTD(); // Ambil data pertama kali
            //this.loadStore();
            this.autoRequestInterval = setInterval(() => {
                this.loadYTD(); // Ambil data setiap interval
                //this.loadStore();
            }, this.intervalDuration * 1000); // Konversi detik ke milidetik
        },

        stopAutoRequest() {
            if (this.autoRequestInterval) {
                clearInterval(this.autoRequestInterval);
                this.autoRequestInterval = null;
            }
        },

        updateInterval() {
            if (this.autoRequestActive) {
                this.stopAutoRequest();
                this.startAutoRequest();
            }
        },

        async loadYTD() {
			let url = Config().apiURL + "/cafe/ytd-overview?" + (this.branchid ? "&branchid=" + this.branchid : "")
			await AxiosWithJar().get(url).then(result => {
				//console.log('ytd cafe: '+ JSON.stringify(result.data))
				if (result.data.sales.length) {
					this.ytd.sales = {
						rekap: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1, 2),
						spd: this.processYTD(result.data.sales, "Info", "SalesExTax", "StoreCount", "Grup", 1, 2, false, false, "NumDay"),
						ytdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "RegionPertareId", "REGION ", 1000000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "RegionPertareId", "REGION ", 1000000000, 2, Rainbow2, "Grup", [2], true),
						spdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", "StoreCount", "RegionPertareId", "REGION ", 1000000, 2, Rainbow, "Grup", [4], true, false, "NumDay"),
					};
					this.ytd.margin = {
						rekap: this.processYTD(result.data.margin, "Info", "Margin", "SalesExTax", "Grup", 0.01, 2),
						ytdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "RegionPertareId", "REGION ", 0.01, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "RegionPertareId", "REGION ", 0.01, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.losses = {
						rekap: this.processYTD(result.data.losses, "Info", "Losses", false, "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.losses, "Info", "", "Losses", false, "RegionPertareId", "REGION ", 1000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.losses, "Info", "", "Losses", false, "RegionPertareId", "REGION ", 1000000, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.basket = {
						invoice: this.processYTD(result.data.basket, "Info", "NoOfInvoice", false, "Grup", 1, 2),
						size: this.processYTD(result.data.basket, "Info", "SalesExTax", "NoOfInvoice", "Grup", 1, 2, false),
					};

				}

				//console.log('ytd sales : ' + JSON.stringify(result.data.sales))
				//console.log('ytd sales cafe ALL: ' + JSON.stringify(this.ytd.sales.rekap))
				//console.log('ytd sales cafe: ' + JSON.stringify(this.ytd.sales.rekap[3]))

				//console.log('ytd losses cafe ALL: ' + JSON.stringify(this.ytd.losses.rekap))
			})
		},
	}
}

</script>
